import * as  React from 'react';
import * as  ReactDOM from 'react-dom';
import { useEffect, useRef, useState } from 'react';
import { TextChatPreview } from '../TextChatPreview';
import { TextChatBtnOptionsState } from '../../TextChatOptions/TextChatOptions';


type TextChatPreviewWrapperProps = TextChatBtnOptionsState & {
  platform: string;
  className?: string;
}

const TextChatPreviewWrapper = (props: TextChatPreviewWrapperProps) => {
  const iframeRef = useRef(null);
  const [iframeDocument, setIframeDocument] = useState(null);

  useEffect(() => {
    if (iframeRef.current) {
      const iframeDoc = iframeRef.current.contentDocument || iframeRef.current.contentWindow.document;
      setIframeDocument(iframeDoc);

      const styles = document.querySelectorAll('style, link[rel="stylesheet"]');
      styles.forEach((style) => {
        const clonedStyle = style.cloneNode(true);
        iframeDoc.head.appendChild(clonedStyle);
      });
    }
  }, []);

  return (
    <iframe
      scrolling="no"
      className="text-chat-preview-wrapper"
      ref={iframeRef}>
      {iframeDocument &&
        ReactDOM.createPortal(
          <TextChatPreview
            noShadow={true}
            shortText={true}
            {...props}
          />,
          iframeDocument.body
        )}
    </iframe>
  );
};

export default TextChatPreviewWrapper;
